import {useState, useEffect} from 'react';
import { useSession } from "../../context/SessionContext";
import { useAuthContext } from '../../context/AuthContext';
import { useLoginServer } from '../../context/LoginServerContext';
import PresetWorkflowInformation from './PresetWorkflowInformation';
import { PresetWorkflowData } from '../../data/PresetWorkflowData';
import { Button } from '@mui/material';

const PresetWorkflowEdit = ({id, handleSave, handleClose, preset, organizationId, presetWorkflow}) => {

    const [value, setValue] = useState('1');
    const [row, setRow] = useState(presetWorkflow);
    const [cfTemplates, setCFTemplates] = useState([]);
    const [errorMessage, setErrorMessage] = useState(false);
    const [savedMessage, setSavedMessage] = useState(false);
    const [message, setMessage] = useState("");
    const [displayMessage, setDisplayMessage] = useState(false);
    const [organizations, setOrganizations] = useState([]);
    const session = useSession();
    const loginServerURL = useLoginServer();
    const {currentToken} = useAuthContext();

    console.log("Main Row: ",row);
    console.log("ID: ",id);
    // console.log("preset:",preset);

    useEffect (() => {
        getCFTemplates();
    },[]);

    useEffect (() => {
        if (id !== "new") { // this is for view only
            try { 
                const sqlCommand = loginServerURL + "/tables/presetWorkflow/" + id;
                console.log(sqlCommand);
                fetch(sqlCommand, {
                    method: 'GET',
                    headers:{
                        "X-ZUMO-AUTH": currentToken,
                        "Content-type":"application/json"
                    }
                }).then ((response) => {
                  if(response.status>= 200 && response.status < 300){
                    return response.json();
                  } else {
                    throw new Error(response.status);
                  }
                })
                .then ((data) => {
                    console.log("PresetWorkflow fetched: ",data);
                    setRow(data.queryable[0])
                }).catch ((error) => {
                    console.log(error);
                });  
            } catch(err) {
                console.log(err);
            }
        }
     
    },[id]);
  
    const handleChange = (e, newValue) => {
        setValue(newValue);
      }
    
      const getCFTemplates = () => {
        try { 
            const sqlCommand = loginServerURL + "/tables/CustomFieldsMetaData";
            console.log(sqlCommand);
            fetch(sqlCommand, {
                method: 'GET',
                headers:{
                    "X-ZUMO-AUTH": currentToken,
                    "Content-type":"application/json"
                }
            }).then ((response) => {
              if(response.status>= 200 && response.status < 300){
                return response.json();
              } else {
                throw new Error(response.status);
              }
            })
            .then ((data) => {
                console.log("Preset Workflows fetched: ",data);
                setCFTemplates(data)
            }).catch ((error) => {
                console.log(error);
            });  
        } catch(err) {
            console.log(err);
        }
    }   
    const getOrganizations = () => {
        try { 
            const sqlCommand = loginServerURL + "/api/Organizations/GetOrganizations";
            console.log(sqlCommand);
            fetch(sqlCommand, {
                method: 'GET',
                headers:{
                    "X-ZUMO-AUTH": currentToken,
                    "Content-type":"application/json"
                }
            }).then ((response) => {
              if(response.status>= 200 && response.status < 300){
                return response.json();
              } else {
                throw new Error(response.status);
              }
            })
            .then ((data) => {
                console.log("Organization fetched: ",data);
                setOrganizations(data)
            }).catch ((error) => {
                console.log(error);
            });  
        } catch(err) {
            console.log(err);
        }
    }

    const validateData = () => {
        setErrorMessage(false);
        setSavedMessage(false);

        if (row.name === undefined || row.name === "") {
            setMessage("Enter workflow Name");
            setDisplayMessage(true);
            return false;
        }
        if (row.assessmentTypesString === undefined || row.assessmentTypesString === "") {
            setMessage("Select at least one Assessment Type");
            setDisplayMessage(true);
            return false;
        }
        if (row.name.toLowerCase().includes("kams") && row.organizationId !== null) {
            setMessage("Name cannot contain KAMS");
            setDisplayMessage(true);
            return false;
        }
       return true;
       
    }
      const handleAdd = async (e) => {
        e.preventDefault();
        var currentRow = row;
        currentRow.assessmentTypes = row.assessmentTypesString.split(",");
        console.log("Validate:",validateData());
        if (validateData() === true){
            try { 
                // const res = await fetch(loginServerURL + "/tables/PresetWorkflow" , {
                const res = await fetch(loginServerURL + "/api/PresetWorkflow/Update" , {
                    method: 'POST',
                    body: JSON.stringify(currentRow),
                    headers:{"Content-type":"application/json",
                            "X-ZUMO-AUTH": currentToken
                    }
                })
                if (!res.ok) {
                    var body = res.body.getReader();
                    var result = await body.read();
                    const decoder = new TextDecoder("utf-8");
                    const message = decoder.decode(result.value);
                    console.log("Result: ",String(message));
                    setMessage(message);
                    setDisplayMessage(true);
                } else {
                    const data = await res.json();
                    console.log("Updated: ",data);
                    setRow(data);
                    handleSave(data);
                    console.log("Updated: ",data);
                    setSavedMessage(true);
                }
                //
                // .then ((data) => {
                //     setRow(data);
                //     handleSave(data);
                //     console.log("Updated: ",data);
                //     setSavedMessage(true);
                // }).catch ((error) => {
                //     console.log(error);
                //     setErrorMessage(true);
                // });  
            } catch(err) {
            console.log(err);
            }
        }

      };
    
      const onFieldChange = (event, newValue, id) => {
        console.log("Case: ",id,  newValue)
        setErrorMessage(false);
        setSavedMessage(false);
        setMessage("");
        setDisplayMessage(false);
        const updatedDate = Date.UTC;
        if (id ==='name') {
           if (preset === true) {
                setRow({...row, name: newValue, kinetisensePresetWorkflow: preset, isFpmEnabled: true, organizationId: organizationId, updatedAt: updatedDate })
           } else {
                setRow({...row, name: newValue, kinetisensePresetWorkflow: preset, organizationId: organizationId, updatedAt: updatedDate })
           }
        } else if (id ==='assessmentTypesString') {
            setRow({...row, assessmentTypesString: newValue, updatedAt: updatedDate });
        } else if (id ==='groupName') {
            setRow({...row, groupName: newValue, updatedAt: updatedDate });
        } else if (id ==='associatedCFTemplate') {
            setRow({...row, associatedCFTemplate: newValue, updatedAt: updatedDate });
        } else if (id ==='isFpmEnabled') {
            setRow({...row, isFpmEnabled: newValue, updatedAt: updatedDate });
        } else {
            console.log("Missing: ",id)
        }
      }

    return (
        <form onSubmit={handleAdd}>
            <div className="formInput" style={{margin: "10px", width: "95%"}}>
                <PresetWorkflowInformation
                    data={row}
                    onFieldChange={onFieldChange}
                    handleClose={handleClose}
                    id={id}
                    cfTemplates={cfTemplates}
                    preset={preset}
                />
                <div className="formButtons" >
                    <div className="left">
                        {errorMessage && <div className="error">An error occured</div>}
                        {savedMessage && <div className="message">Workflow Saved</div>}
                        {displayMessage && <div className="error">{message}</div>}
                    </div>
                    <div className="right">
                        {row.id === null &&
                            <Button  
                                type="submit"
                                variant="contained"
                                className="button"
                            >
                                Save
                            </Button>
                        }
                        {/* <Button  
                             type="submit"
                             variant="contained"
                             className="button"
                        >
                            Save
                        </Button> */}
                        
                    </div>
                </div>
            </div>
        </form>
            
    );
}

export default PresetWorkflowEdit;